import React from 'react';
interface SectionEyebrowProps {
  text: string;
  className?: string;
}
// Eyebrow labels removed per design request — component returns null
// to silently no-op all existing usages across the site.
export function SectionEyebrow({
  text,
  className
}: SectionEyebrowProps) {
  return null;
}